module.exports = __webpack_public_path__ + "img/gatesofolympus.6e07e71a.gif";